/* generated by pull.js */
export default {
  "de": () => import(/* webpackChunkName: "addon-l10n-de" */ "../addons-l10n/de.json"),
  "es": () => import(/* webpackChunkName: "addon-l10n-es" */ "../addons-l10n/es.json"),
  "fi": () => import(/* webpackChunkName: "addon-l10n-fi" */ "../addons-l10n/fi.json"),
  "fr": () => import(/* webpackChunkName: "addon-l10n-fr" */ "../addons-l10n/fr.json"),
  "hu": () => import(/* webpackChunkName: "addon-l10n-hu" */ "../addons-l10n/hu.json"),
  "it": () => import(/* webpackChunkName: "addon-l10n-it" */ "../addons-l10n/it.json"),
  "ja": () => import(/* webpackChunkName: "addon-l10n-ja" */ "../addons-l10n/ja.json"),
  "ko": () => import(/* webpackChunkName: "addon-l10n-ko" */ "../addons-l10n/ko.json"),
  "nl": () => import(/* webpackChunkName: "addon-l10n-nl" */ "../addons-l10n/nl.json"),
  "pl": () => import(/* webpackChunkName: "addon-l10n-pl" */ "../addons-l10n/pl.json"),
  "pt": () => import(/* webpackChunkName: "addon-l10n-pt" */ "../addons-l10n/pt.json"),
  "ro": () => import(/* webpackChunkName: "addon-l10n-ro" */ "../addons-l10n/ro.json"),
  "ru": () => import(/* webpackChunkName: "addon-l10n-ru" */ "../addons-l10n/ru.json"),
  "sl": () => import(/* webpackChunkName: "addon-l10n-sl" */ "../addons-l10n/sl.json"),
  "tr": () => import(/* webpackChunkName: "addon-l10n-tr" */ "../addons-l10n/tr.json"),
  "zh-cn": () => import(/* webpackChunkName: "addon-l10n-zh-cn" */ "../addons-l10n/zh-cn.json"),
  "zh-tw": () => import(/* webpackChunkName: "addon-l10n-zh-tw" */ "../addons-l10n/zh-tw.json"),
};
